(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuntius-renovacion"] && !Shopify.designMode) return;
  try {
    
(()=>{const root=document.querySelector('.nh-renov');if(!root)return;let chosen=1;const prices={1:79,2:141,3:194};const money=n=>'S/ '+n.toFixed(2);function sync(n){chosen=Number(n);root.querySelectorAll('.pack-select').forEach(e=>e.value=String(chosen));root.querySelectorAll('.product-price').forEach(e=>e.textContent=money(prices[chosen]));root.querySelectorAll('.amount').forEach(e=>e.textContent=money(prices[chosen]));}root.querySelectorAll('.pack-select').forEach(e=>e.addEventListener('change',()=>sync(e.value)));})();

  } catch(e) { console.error(e); }
})();
})();
